export default "__VITE_ASSET__DEJ6$1UM__"